import invariant from 'tiny-invariant';

// Given a map with breakpoints as keys, this will return a sorted list of those breakpoints.
// "default" is a special keyword reserved here.
export const sortedNonDefaultBreakpoints = (map) => {
  const breakpoints = Object.keys(map).filter(key => key !== 'default');
  breakpoints.sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
  return breakpoints;
};

// Returns an interval [lb, ub) representing the smallest interval in which
// the viewport width could lie according to breakpoint flag information.
const decideBreakpointBounds = (breakpoints, breakpointFlags) => {
  const INF = 1000000; // Just a reasonable value for infinity, in breakpoint world.
  invariant(breakpoints.length === breakpointFlags.length, 'Breakpoints and Flag counts must match.');
  const n = breakpoints.length;
  if (!breakpointFlags[0]) return [0, breakpoints[0]];
  if (breakpointFlags[n - 1]) return [breakpoints[n - 1], INF];
  let i = 0;
  while (i + 1 < n && breakpointFlags[i + 1]) ++i;
  invariant(i + 1 < n, 'Invariant broken: i + 1 is expected to be a valid index.');
  return [breakpoints[i], breakpoints[i + 1]];
};

export const getBreakpointSpecifiedValue = (breakpoints, breakpointFlags, valueSpec) => {
  invariant(breakpoints.length === breakpointFlags.length, 'Breakpoints and Flag counts must match.');
  if (breakpointFlags.length === 0 || !breakpointFlags[0]) return valueSpec.default;
  const [lb, ub] = decideBreakpointBounds(breakpoints, breakpointFlags);
  // Get the breakpoints specified in the specification.
  const specBreakpoints = sortedNonDefaultBreakpoints(valueSpec);
  // Find the value associated with the largest breakpoint in the interval [lb, ub)
  let bestValue = valueSpec.default;
  for (let i = 0; i < specBreakpoints.length; ++i) {
    const specBreakpoint = parseInt(specBreakpoints[i], 10);
    if (lb <= specBreakpoint && specBreakpoint < ub) {
      bestValue = valueSpec[specBreakpoints[i]];
    }
  }
  return bestValue;
};
